<div class="container" style="margin-top: 30px; padding-bottom: 50px;" *ngIf="practitioner">
  <div class="zaya-back-button" style="margin-bottom: 30px;" (click)="goBack()">
    <fa-icon [icon]="backIcon"></fa-icon>
    <span i18n="button|Link to return users to search results page.@@buttonBackToSearch">Go back to search results</span>
  </div>

  <app-booking-form #booking [practitioner]="practitioner" [servicesSelected]="selectedTherapies" (bookingCompleted)="openConfirmation()"></app-booking-form>
  <app-modal-notification #confirmation></app-modal-notification>
  <app-practitioner-edit #practitionerEdit [practitioner]="practitioner" (updated)="reloadStatusBanner(practitioner.id)"></app-practitioner-edit>
  <app-status-banner #statusBanner *ngIf="(canEdit | async) && practitioner.status != practitionerStatusEnum.Approved" [practitioner]="practitioner"></app-status-banner>

  <div class="row px-md-4 px-sm-1 gray-text">
    <div class="col-xl-3 col-md-4 px-md-4 px-sm-1">
      <ng-container *ngIf="isMobileScreen">
        <div class="flex-fill d-flex justify-content-between align-items-center">
          <div class="profile-name flex-fill">{{ practitioner.getFullName() }}</div>
        </div>
        <div class="specialty-text">{{ practitioner.title}}</div>
        <app-star-ratings *ngIf="practitioner.rating" [rating]="practitioner.rating.rating" [count]="practitioner.rating.total"></app-star-ratings>
      </ng-container>
      <img *ngIf="!isMobileScreen" class="profile-image mb-4" alt="profile-image" [src]="practitioner.profileImage" sizeMatch="height">
      <div *ngIf="isMobileScreen" class="d-flex justify-content-center">
        <img class="profile-image mb-4" alt="profile-image" [src]="practitioner.profileImage" sizeMatch="height" style="max-height: 250px; max-width: 250px;">
      </div>
      <div class="text-center profile-subheading cost">
        <span style="vertical-align: middle;"><b><ng-container i18n="search result|Shows what the starting cost of the service is.@@labelStartingCost">
          Starting at</ng-container> £{{ practitioner.getStartingCost() }}</b>
        </span>
      </div>
      <div class="text-center">
        <span style="vertical-align: middle;">{{ practitioner.getLanguages() }}</span>
      </div>
      <div class="text-center">
        <ng-container *ngIf="practitioner.offersVirtual else noVirtual" i18n="label|Present when a practitioner offers online services.@@labelOnlineConsultations">
          Online consultations
        </ng-container>
        <ng-template #noVirtual>
          <ng-container i18n="label|Present when a practitioner does not offer online services.@@labelNoOnlineConsultations">
            No online consultations
          </ng-container>
        </ng-template>

        <ng-container *ngIf="isMobileScreen">
          <br>
          <button
            gaEvent
            gaCategory="Practitioner Profile"
            [gaAction]="'Book a session'"
            [gaLabel]="'click'"
            class="btn btn-primary schedule-btn mt-3"
            type="button"
            (click)="booking.open()"
            i18n="button|The button text for booking an appointment.@@buttonScheduleVisit">
            Book a session</button>
        </ng-container>
      </div>

      <hr>

      <div class="profile-subheading" i18n="label|The address of the practitioner.@@labelLocation">
        Location
      </div>
      <div class="profile-address">
        <a href="https://www.google.com/maps/dir/?api=1&destination={{ practitioner.location.getFullAddress() }}" target="_blank">
          {{ practitioner.location.getFullAddress() }}
        </a>
      </div>
      <agm-map [latitude]="practitioner.location.latitude" [longitude]="practitioner.location.longitude" [zoom]="12">
        <agm-marker [latitude]="practitioner.location.latitude" [longitude]="practitioner.location.longitude" [markerDraggable]="false"></agm-marker>
      </agm-map>
    </div>

    <div class="col-xl-9 col-md-8 px-md-4 px-sm-1">
      <ng-container *ngIf="!isMobileScreen">
        <div class="flex-fill d-flex justify-content-between align-items-center">
          <div class="profile-name flex-fill">{{ practitioner.getFullName() }}</div>
          <button
            *ngIf="!(canEdit | async)"
            gaEvent
            gaCategory="Practitioner Profile"
            [gaAction]="'Book a session'"
            [gaLabel]="'click'"
            class="btn btn-primary schedule-btn"
            type="button"
            (click)="booking.open()"
            i18n="button|The button text for booking an appointment.@@buttonScheduleVisit">
            Book a session</button>
          <div class="d-inline-block" ngbDropdown #editDrop="ngbDropdown">
            <button
              *ngIf="canEdit | async"
              gaEvent
              gaCategory="'Edit profile'"
              [gaAction]="'click'"
              class="btn btn-primary schedule-btn"
              type="button"
              i18n="button|The button text for editing a profile.@@buttonEditProfile"
              id="editDropdown"
              ngbDropdownAnchor
              (click)="editDrop.open()">Edit</button>
            <div ngbDropdownMenu aria-labelledby="editDropdown">
              <button ngbDropdownItem (click)="practitionerEdit.open(practitionerEditEnum.Photo)">Profile Photo</button>
              <button ngbDropdownItem (click)="practitionerEdit.open(practitionerEditEnum.Personal)">Personal Information</button>
              <button ngbDropdownItem (click)="practitionerEdit.open(practitionerEditEnum.Business)">Business Information</button>
              <button ngbDropdownItem (click)="practitionerEdit.open(practitionerEditEnum.Experience)">Experience Information</button>
              <button ngbDropdownItem (click)="practitionerEdit.open(practitionerEditEnum.Conditions)">Conditions</button>
              <button ngbDropdownItem (click)="practitionerEdit.open(practitionerEditEnum.Specialties)">Services</button>
              <button ngbDropdownItem (click)="practitionerEdit.open(practitionerEditEnum.Bio)">Bio</button>
            </div>
          </div>
        </div>
        <div class="specialty-text" *ngFor="let specialty of practitioner.specialties">{{ specialty.name }}</div>
        <app-star-ratings *ngIf="practitioner.rating" [rating]="practitioner.rating.rating" [count]="practitioner.rating.total"></app-star-ratings>
      </ng-container>

      <div class="row">
        <div class="col-xl-6 col-sm-12 mt-5">
          <div class="profile-subheading" i18n="label|Conditions a practitioner specializes in.@@labelConditionsSpecialize">Conditions I specialize in</div>
          <div class="row">
            <div class="profile-detail col-sm-6" *ngFor="let conidition of practitioner.conditions">- {{ conidition }}</div>
          </div>
        </div>
      </div>

      <hr class="my-4">

      <div>
        <div class="profile-subheading" i18n="label|List of practitioner services.@@labelServiceMenu">My Services</div>
        <div class="d-flex flex-fill mb-2 zaya-form-help-text" i18n="label|Help text for the services a practitioner offers.@@labelApplicationServicesHelpText">
          For a description of each service click the <fa-icon [icon]="questionIcon" class="ml-1"></fa-icon> &nbsp;icon.
        </div>
        <div class="row">
          <div class="col-xs-12 col-md-6" *ngFor="let specialty of practitioner.specialties">
            <div class="profile-heading"><b>{{ specialty.name + ' services' }}</b></div>
            <div class="row">
              <div class="mb-3 col-sm-12" *ngFor="let therapy of specialty.therapies">
                <!-- <input type="checkbox" class="form-check-input therapy-checkbox" id="therapy-{{therapy.name}}" (click)="onTherapySelected(therapy)"> -->
                <div class="therapy-select d-flex align-items-center" triggers="mouseenter:mouseleave" ngbPopover="{{therapy.description}}" popoverTitle="{{therapy.name}}">
                  {{therapy.name}} <fa-icon [icon]="questionIcon" class="ml-1"></fa-icon>
                </div>
                <!-- <div style="margin-top: 5px; margin-bottom: 10px;">{{ therapy.description }}</div> -->
                <div>£{{ therapy.cost }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="mb-4 mt-2">

      <div>
        <div class="profile-subheading">
          <ng-container i18n="label|Bio that belongs to a practitioner.@@labelBio">My Bio</ng-container>
        </div>
        <div class="profile-detail">{{ practitioner.bio }}</div>

        <div class="profile-subheading mt-5">
          <ng-container i18n="label|Approach that belongs to a practitioner.@@labelApproach">What to expect in a session</ng-container>
        </div>
        <div class="profile-detail">{{ practitioner.approach }}</div>
      </div>

      <hr class="my-4">

      <div class="profile-subheading" i18n="label|Practitioner education and licenses.@@labelEducationLicenses">Education/Training</div>
      <div class="row">
        <span class="profile-detail col-sm-12" *ngFor="let education of practitioner.education">- {{education.name + ', ' + education.degree}}</span>
        <div class="profile-detail col-sm-12" *ngFor="let license of practitioner.licenses">- {{license}}</div>
      </div>

      <ng-container *ngIf="practitioner.documents && getProfessionalBodies(practitioner.documents).length">
        <div class="profile-subheading mt-5">
          <ng-container i18n="label|Professional bodies that belongs to a practitioner.@@labelProfessionalBody">Professional bodies I belong to</ng-container>
        </div>
        <div class="row">
          <span class="profile-detail col-sm-12" *ngFor="let document of getProfessionalBodies(practitioner.documents)">- {{document.name}}</span>
        </div>
      </ng-container>

      <ng-container *ngIf="practitioner.documents && getAccreditedRegisters(practitioner.documents).length">
        <div class="profile-subheading mt-5">
          <ng-container i18n="label|Accredited registers that belongs to a practitioner.@@labelAccreditedRegisters">Accredited register memberships</ng-container>
        </div>
        <span class="row">
          <span class="profile-detail col-sm-12" *ngFor="let document of getAccreditedRegisters(practitioner.documents)">- {{document.name}}</span>
        </span>
      </ng-container>

      <hr class="my-4">

      <div>
        <div class="profile-subheading" style="margin-bottom: 20px;" i18n="label|The ratings and reviews of a practitioner.@@labelRatingsReviews">Ratings and reviews</div>
        <div *ngIf="practitioner.testimonials.length else noTestimonials">
          <div class="card-subtitle mt-4">
            <div class="d-flex flex-fill align-items-end" style="margin: 15px auto;">
              <div class="card-subtitle d-flex flex-wrap">
                <ng-container *ngFor="let value of values; let i = index">
                  <span
                    class="card-pill mb-2"
                    ngbPopover="{{value.details}}"
                    triggers="mouseenter:mouseleave"
                    *ngIf="practitioner.rating.values[value.property]">
                    {{value.name}} ({{ practitioner.rating.values[value.property] }})
                  </span>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="row d-flex mb-3" *ngFor="let testimonial of practitioner.testimonials">
            <div class="col-md-3">
              <div class="d-flex flex-column align-items-start">
                <app-star-ratings [rating]="testimonial.rating" [showRating]="false"></app-star-ratings>
                <div class="testimonial-detail-small">{{ testimonial.firstName }}</div>
                <div class="testimonial-detail-small">{{ testimonial.createdAt | date:'mediumDate' }}</div>
              </div>
            </div>
            <div class="col-md-9">
              <div>{{ testimonial.description }}</div>
            </div>
          </div>
        </div>
        <ng-template #noTestimonials>
          <ng-container i18n="label|Empty state when a pracitioner does not have reviews.@@labelNoRatingsReviews">No reviews available</ng-container>
        </ng-template>
      </div>
    </div>
  </div>
</div>
